import { useEffect } from "react";

const Home = () => {
  // Pretendard GOV 로드 (없어도 동작하지만, 있으면 폰트 적용)
  useEffect(() => {
    const id = "pretendard-gov";
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href =
        "https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard-gov.css";
      document.head.appendChild(link);
    }
  }, []);

  return (
    <section id="home" className="home">
      <div className="inner" data-aos="fade-up" data-aos-duration="900">
        {/* 메인 카피 */}
        <h1
          className="hero-ko"
          style={{
            fontFamily: "'Pretendard GOV','Pretendard','Nanum Gothic',sans-serif",
            fontWeight: 700,
            color: "#e3e3e3",
            fontSize: "clamp(32px, 5.2vw, 80px)",
            lineHeight: 1.4,
            margin: "0 0 18px",
          }}
        >
          더 나은 세상을 여는 기술,<br />
          아미소프트
        </h1>

        {/* 서브 카피 */}
        <p
          className="hero-en"
          style={{
            fontFamily: "'Pretendard GOV','Pretendard','Nanum Gothic',sans-serif",
            fontWeight: 700,
            color: "#e3e3e3",
            fontSize: "clamp(16px, 2.2vw, 34px)",   // ← 약간 작게
            margin: "48px 0 48px",
            opacity: 0.95,
          }}
        >
          Innovating the Future with Technology
        </p>

        {/* CTA */}
        <a className="cta" href="#intro" aria-label="Learn more">
          Learn More
        </a>
      </div>
    </section>
  );
};

export default Home;
